import React from "react";
import { Box, Icon, type IconProps } from "@chakra-ui/react";
import { type CircleProps } from "./circle-progress";

export function ProgressBlur({ size, strokeWidth, percentage, ...props }: IconProps & CircleProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * Math.PI * 2;
  const arcOffset = circumference * ((100 - percentage) / 100);

  return (
    <Icon viewBox={`0 0 ${size} ${size}`} transform="rotate(-90deg)" boxSize={size} {...props}>
      <Box
        as="filter"
        id="borderBlur"
        x="0.398438"
        y="0.199951"
        width={size}
        height={size}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <Box as="feFlood" floodOpacity="0" result="BackgroundImageFix" />
        <Box as="feBlend" mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <Box as="feGaussianBlur" stdDeviation="14" result="effect1_foregroundBlur_471_477" />
      </Box>
      <Box
        as="circle"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="grass"
        filter="url(#borderBlur)"
        strokeWidth={`${strokeWidth}px`}
        strokeDasharray={circumference}
        strokeDashoffset={arcOffset}
        strokeLinecap="round"
        transitionProperty="stroke-dasharray, stroke"
        transitionDuration="0.6s"
        transitionTimingFunction="linear"
      />
    </Icon>
  );
}
